import React, { useEffect, useState, useRef } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { Collapse } from "reactstrap";
import config from "../../config";
import { useProfile } from "../../contexts/ProfileContext";
import "react-toastify/dist/ReactToastify.css";
import Brand_icon from "../../assets/images/Brand_icon.png";

import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";

import "./leftSidebar.css";
import UserProfile from "./UserProfile";
import { Avatar } from "@mui/material";
import { MdArrowOutward, MdVerified } from "react-icons/md";
import { FaHourglassHalf } from "react-icons/fa";
import { FcCancel } from "react-icons/fc";
import { RiCustomerService2Line } from "react-icons/ri";
import { IoClose } from "react-icons/io5";

function LeftSidebarMenu({ isExpanded, setIsExpanded, drawerOpen, setDrawerOpen, sidebarRef }) {
    const modalRef = useRef(null);
    const { profileData, setProfileData } = useProfile();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const [activeMenu, setActiveMenu] = useState("");

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setIsModalOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [modalRef]);

    const logout = () => {
        // Clear tokens from both localStorage and sessionStorage
        localStorage.removeItem("authUser");
        localStorage.removeItem("refreshToken");
        sessionStorage.removeItem("authUser");
        sessionStorage.removeItem("refreshToken");
        localStorage.clear();
        sessionStorage.clear();
        setProfileData({}); // Clear profile data in Context
        navigate("/login");
    };

    const toggleDrawer = () => {
        setDrawerOpen((prev) => !prev);
    };

    useEffect(() => {
        // Profile data will be fetched by the ProfileProvider
    }, [profileData]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setIsModalOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [modalRef, sidebarRef]);

    const handleButtonClick = () => {
        toggleDrawer();
        navigate("/list-property/welcome");
    };

    const handleMenuClick = (menu) => {
        toggleDrawer();
        setActiveMenu(menu);
        // navigate("/favorites");
    };

    const pathsToCheck = [
        "/services/financing",
        "/get-qualified/Step-1",
        "/get-qualified/Step-2",
        "/get-qualified/Step-3",
        "/get-qualified/Step-4",
        "/get-qualified/Step-5",
        "/get-qualified/Step-6",
        "/get-qualified/Step-7",
        "/get-qualified/success",
        "/sell",
    ];
    useEffect(() => {
        const currentPath = location.pathname;
        if (pathsToCheck.some((path) => currentPath.includes(path))) {
        } else {
        }
    }, [location.pathname]);
    const truncateName = (name = "") => {
        return name.length > 13 ? name.slice(0, 13) + "..." : name;
    };
    const renderProfilePicture = (profile_pic) => {
        if (profile_pic && profile_pic?.startsWith("http")) {
            return profile_pic;
        } else if (profile_pic.startsWith("/public/images")) {
            return "https://image.onmls.com" + profile_pic;
        } else {
            return `https://image.onmls.com/public/images/${profile_pic}`;
        }
    };
    return (
        <div className="tw-relative   tw-h-[90vh] ">
            <div className="tw-sticky  tw-w-full  tw-left-0  tw-top-0  ">
                <div className="tw-h-[55px] tw-w-full tw-flex tw-justify-center tw-items-center tw-bg-tertiary">
                    <div className="tw-flex tw-justify-between">
                        <div className="logoWrapper">
                            <img src={Brand_icon} alt="AiRE BROKERS logo" className="logo tw-w-[35px] tw-h-[35px]" />
                            <span className={`brandName tw-text-[18px] ${isExpanded ? "" : "tw-hidden"}`}>{config.get("COMPANY_NAME")}</span>
                        </div>
                    </div>
                </div>
            </div>

            <nav
                ref={sidebarRef}
                className={`sidebar max-sm:tw-h-full tw-flex tw-flex-col tw-justify-between  max-sm:tw-justify-start tw-h-full tw-bg-white  max-sm:tw-mt-0 tw-pb-1  max-sm:tw-overflow-y-auto tw-left-0 tw-top-0 tw-z-[1050] max-sm:tw-z-[50000]   ${!isExpanded ? "tw-px-2" : "tw-px-4"} ${drawerOpen ? "open" : "closed"} tw-transition-all tw-duration-300 md:tw-static md:tw-w-full`}
            >
                <div className=" ">
                    {/* Mobile close button - only visible when sidebar is open */}
                    {drawerOpen && (
                        <button
                            onClick={toggleDrawer}
                            className="md:tw-hidden tw-absolute tw-top-4 tw-right-4 tw-p-2 tw-text-gray-800 hover:tw-text-gray-600 tw-z-[50002] tw-opacity-100 tw-bg-white tw-rounded-full tw-shadow-lg"
                            style={{ opacity: 1 }}
                            aria-label="Close menu"
                        >
                            <IoClose size={28} color="#000" />
                        </button>
                    )}
                    <div className={`tw-flex tw-flex-col  tw-mt-3`}>
                        <NavLink
                            to="/properties"
                            className={({ isActive }) =>
                                `nav-linke max-lg:tw-gap-[7px] hover:tw-text-secondary tw-no-underline ${isActive ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`
                            }
                            onClick={() => handleMenuClick("properties")}
                        >
                            <i
                                className={`fi fi-rs-map-marker tw-text-[20px] max-lg:tw-text-[16px] ${!isExpanded && "tw-w-full tw-text-center"}`}
                            ></i>
                            {/* <LiaMapMarkedAltSolid className={`${!isExpanded && "tw-w-full  tw-text-center"} tw-text-[24px]`} /> */}
                            <span className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>Find Properties</span>
                        </NavLink>

                        <NavLink
                            to="/MyProperties"
                            className={({ isActive }) =>
                                `nav-linke max-lg:tw-gap-[7px] hover:tw-text-secondary tw-no-underline  ${isActive ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`
                            }
                            onClick={() => handleMenuClick("myProperties")}
                        >
                            <i className={`fi fi-rs-city tw-text-[20px] max-lg:tw-text-[16px] ${!isExpanded && "tw-w-full tw-text-center"}`}></i>{" "}
                            {/* <HiOutlineHome className={`${!isExpanded && "tw-w-full tw-text-center"} tw-text-[24px]`} /> */}
                            <span style={{}} className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>
                                My Properties
                            </span>
                        </NavLink>

                        <NavLink
                            to="/chat"
                            className={({ isActive }) => {
                                const isCurrentlyActive = isActive && location.search.includes("chat_id");

                                return `nav-linke max-lg:tw-gap-[7px] hover:tw-text-secondary tw-no-underline  ${isCurrentlyActive ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`;
                            }}
                            onClick={() => handleMenuClick("chat")}
                        >
                            <i className={`fi fi-rr-comment tw-text-[20px] max-lg:tw-text-[16px] ${!isExpanded && "tw-w-full tw-text-center"}`}></i>
                            {/* <HiOutlineChatBubbleLeftRight className={`${!isExpanded && "tw-w-full tw-text-center"} tw-text-[24px]`} /> */}
                            <span className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>Chat</span>
                        </NavLink>

                        <NavLink
                            to="/documents/templates"
                            className={({ isActive }) =>
                                `nav-linke max-lg:tw-gap-[7px] hover:tw-text-secondary tw-no-underline  ${isActive ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`
                            }
                            onClick={() => handleMenuClick("templates")}
                        >
                            <i
                                className={`fi fi-rr-objects-column tw-text-[20px] max-lg:tw-text-[16px] ${!isExpanded && "tw-w-full tw-text-center"}`}
                            ></i>
                            {/* <PiFilesLight className={`${!isExpanded && "tw-w-full tw-text-center"} tw-text-[24px]`} /> */}
                            <span className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>Templates</span>
                        </NavLink>

                        <NavLink
                            to="/users/docs"
                            className={({ isActive }) =>
                                `nav-linke max-lg:tw-gap-[7px] hover:tw-text-secondary tw-no-underline  ${isActive ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`
                            }
                            onClick={() => handleMenuClick("userDocuments")}
                        >
                            <i className={`fi fi-rr-document tw-text-[20px] max-lg:tw-text-[16px] ${!isExpanded && "tw-w-full tw-text-center"}`}></i>
                            {/* <IoDocumentsOutline className={`${!isExpanded && "tw-w-full tw-text-center"} tw-text-[24px]`} /> */}
                            <span className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>User Documents</span>
                        </NavLink>

                        <NavLink
                            to="/favorites"
                            className={({ isActive }) => {
                                return `nav-linke max-lg:tw-gap-[7px] hover:tw-text-secondary tw-no-underline  ${isActive ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`;
                            }}
                            onClick={() => handleMenuClick("favorites")}
                        >
                            <i className={`fi fi-rr-heart ${!isExpanded && "tw-w-full tw-text-center"} tw-text-[20px] max-lg:tw-text-[16px]`}></i>
                            {/* <PiHeart className={`${!isExpanded && "tw-w-full tw-text-center"} tw-text-[24px]`} /> */}
                            <span className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>Favorites</span>
                        </NavLink>

                        <NavLink
                            to="#"
                            onClick={toggleDropdown}
                            className={`nav-linke max-lg:tw-gap-[7px] tw-text-center hover:tw-text-secondary tw-no-underline  ${activeMenu === "insuranceQuote" || activeMenu === "financing" || activeMenu === "titleServices" || activeMenu === "homeInspector" ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`} // Apply active class based on isOpen
                        >
                            <i
                                className={`fi fi-rs-heart-partner-handshake tw-text-[20px] max-lg:tw-text-[16px] ${!isExpanded && "tw-w-full tw-text-center"}`}
                            ></i>

                            {/* <MdOutlineHandshake className={`${!isExpanded && "tw-w-full tw-text-center"} tw-text-[24px]`} /> */}
                            <span className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>Services</span>
                            <span className={`${isExpanded ? "" : "tw-hidden"} tw-ml-auto`}>
                                {isOpen ? <KeyboardArrowUpOutlinedIcon className="text-[#001659]" /> : <KeyboardArrowDownOutlinedIcon />}
                            </span>
                        </NavLink>

                        <Collapse isOpen={isOpen}>
                            <div className=" tw-flex tw-flex-col  tw-pb-1 tw-rounded-lg tw-mt-1">
                                <NavLink
                                    to="/services/financing"
                                    className={` ${isExpanded ? "" : "tw-hidden"} font-roboto font-normal font-medium tw-pl-9 text-[10px]  2xl:tw-text-[13px] between:tw-text-[14px] leading-[19px] text-black tw-flex tw-gap-2 tw-px-1 tw-text-[11px] tw-items-center tw-py-[2px] tw-mb-1.5 tw-rounded hover:tw-active-link`}
                                    onClick={() => handleMenuClick("financing")}
                                >
                                    Financing
                                </NavLink>
                                <NavLink
                                    to="/services/insurance-quote"
                                    className={` ${isExpanded ? "" : "tw-hidden"} font-roboto font-normal font-medium tw-pl-9 text-[10px]  2xl:tw-text-[13px] between:tw-text-[14px] leading-[19px] text-black tw-flex tw-gap-2 tw-px-1 tw-text-[11px] tw-items-center tw-py-[2px] tw-mb-1.5 tw-rounded hover:tw-active-link`}
                                    onClick={() => handleMenuClick("insuranceQuote")}
                                >
                                    Insurance Quote
                                </NavLink>
                                <NavLink
                                    to="/services/title-services"
                                    className={` ${isExpanded ? "" : "tw-hidden"} font-roboto font-normal font-medium tw-pl-9 text-[10px]  2xl:tw-text-[13px] between:tw-text-[14px] leading-[19px] text-black tw-flex tw-gap-2 tw-px-1 tw-text-[11px] tw-items-center tw-py-[2px] tw-mb-1.5 tw-rounded hover:tw-active-link`}
                                    onClick={() => handleMenuClick("titleServices")}
                                >
                                    Title Services
                                </NavLink>
                                <NavLink
                                    to="/services/home-Inspection"
                                    className={` ${isExpanded ? "" : "tw-hidden"} font-roboto font-normal font-medium tw-pl-9 text-[10px]  2xl:tw-text-[13px] between:tw-text-[14px] leading-[19px] text-black tw-flex tw-gap-2 tw-px-1 tw-text-[11px] tw-items-center tw-py-[2px] tw-mb-1.5 tw-rounded hover:tw-active-link`}
                                    onClick={() => handleMenuClick("homeInspector")}
                                >
                                    Home Inspection
                                </NavLink>
                            </div>
                        </Collapse>
                        <NavLink
                            to="/chat"
                            className={({ isActive }) => {
                                const isCurrentlyActive = isActive && !location.search.includes("chat_id");

                                return `nav-linke max-lg:tw-gap-[7px] hover:tw-text-secondary tw-no-underline  ${isCurrentlyActive ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`;
                            }}
                            onClick={() => handleMenuClick("chat/customer-support")}
                        >
                            <RiCustomerService2Line size={20} className={` tw-font-thin  ${!isExpanded && "tw-w-full tw-text-center"}`} />

                            <span className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>Customer Support</span>
                        </NavLink>
                    </div>
                </div>
                <div>
                    <div className={`tw-flex tw-w-full  tw-justify-center tw-mb-2`}>
                        <div className={`${isExpanded ? "" : "tw-hidden"} sidebar-list-bg tw-bg-tertiary tw-w-full tw-p-3`}>
                            <div className="tw-text-center">
                                <p className="tw-text-white tw-font-semibold tw-text-[20px] max-lg:tw-text-[16px]">Ready To Sell?</p>
                                <p className="tw-text-white tw-text-[11px]">Use our advanced AI to sell your home fast, no commissions!</p>
                            </div>
                            <button
                                onClick={handleButtonClick}
                                className="tw-bg-secondary tw-text-white hover:tw-text-white hover:tw-bg-secondary_hover tw-font-Space_Grotesk tw-font-[400] tw-w-full tw-p-1 2xl:tw-text-[22px] between:tw-text-[18px] tw-rounded-md  tw-flex tw-items-center tw-gap-1 tw-justify-center tw-mb-2 tw-mt-1 2xl:tw-mt-4 2xl:tw-mb-6"
                            >
                                List Now
                                <MdArrowOutward />
                            </button>
                        </div>
                        <button
                            onClick={handleButtonClick}
                            className={`${!isExpanded ? "" : "tw-hidden"} tw-text-[12px] tw-bg-secondary  tw-text-white hover:tw-text-white hover:tw-bg-secondary_hover tw-font-Space_Grotesk tw-font-[400] tw-w-full tw-p-1 2xl:tw-text-[22px] between:tw-text-[18px] tw-rounded-md  tw-flex tw-items-center tw-gap-1 tw-justify-center tw-mb-2 tw-mt-1 2xl:tw-mt-4 2xl:tw-mb-6`}
                        >
                            List Now
                        </button>
                    </div>
                    <div className={`tw-flex tw-items-center ${isExpanded ? "" : "tw-justify-center"}  tw-gap-3 tw-mt-10 tw-pb-3`}>
                        {profileData?.profile_pic ? (
                            <Avatar
                                src={renderProfilePicture(profileData?.profile_pic)}
                                alt="User profile"
                                className="tw-shadow-md tw-border"
                                sx={{ width: 40, height: 40 }}
                            />
                        ) : (
                            <UserProfile name={`${profileData?.first_name} ${profileData?.last_name}`} fallbackImageUrl={profileData?.profile_pic} />
                        )}

                        <div className={`${isExpanded ? "" : "tw-hidden"}`}>
                            <div className="tw-flex tw-items-center tw-gap-2 tw-mt-2">
                                <p className="tw-font-semibold tw-text-lg ">
                                    {truncateName(profileData?.first_name)} {truncateName(profileData?.last_name)}
                                </p>
                                {profileData?.verification_status === "approved" ? (
                                    <>
                                        <span>
                                            <MdVerified color="#2bba00" />
                                        </span>
                                    </>
                                ) : profileData?.verification_status === "pending" ? (
                                    <>
                                        <span>
                                            <FaHourglassHalf color="#F2C94C" />
                                        </span>
                                    </>
                                ) : profileData?.verification_status === "rejected" ? (
                                    <>
                                        <span>
                                            <FcCancel color="red" />
                                        </span>
                                    </>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div
                        onClick={logout}
                        className={`tw-flex ${isExpanded ? "" : "tw-justify-center"}  tw-gap-3 tw-mt-3  tw-pb-3 tw-px-2 tw-text-black tw-font-semibold tw-items-start  `}
                        style={{ cursor: "pointer" }}
                    >
                        {/* <img width={20} height={20} src={require("../../assets/images/sidebar-imgs/log-out.png")} alt="Log Out" /> */}
                        <span className={`${isExpanded ? "" : "tw-p-2 tw-px-3 tw-text-white tw-w-fit tw-rounded-full tw-bg-primary"}`}>
                            <i className={`fi fi-ts-arrow-left-from-arc tw-mt-1 tw-text-[16px] `}></i>
                        </span>
                        <span className={`${isExpanded ? "" : "tw-hidden"} `}>Logout</span>
                    </div>
                </div>
            </nav>
        </div>
    );
}

export default LeftSidebarMenu;
